import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPolicies = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 56,
	height: 56,
	fill: "none",
	viewBox: "0 0 56 56",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M28 .875c.236 0 .463.096.628.265A28 28 0 0 0 48.99 9.625a.875.875 0 0 1 .883.824L49 10.5l.874-.05v.007l.001.02.004.073q.005.097.01.277c.009.242.017.594.02 1.045.006.902-.012 2.2-.105 3.793-.187 3.184-.677 7.562-1.892 12.332-2.426 9.526-7.775 20.736-19.498 27.024a.88.88 0 0 1-.828 0C15.863 48.733 10.514 37.523 8.088 27.997c-1.215-4.77-1.705-9.148-1.892-12.332a59 59 0 0 1-.105-3.793 39 39 0 0 1 .03-1.322l.004-.073.001-.02v-.007L7 10.5l-.873-.051a.875.875 0 0 1 .882-.824A28 28 0 0 0 27.373 1.14.88.88 0 0 1 28 .875M7.847 11.371q-.005.227-.006.512c-.006.869.011 2.128.102 3.679.182 3.104.66 7.367 1.84 12.003C12.12 36.737 17.172 47.251 28 53.253c10.829-6.002 15.88-16.516 18.216-25.688 1.18-4.636 1.659-8.899 1.84-12.003a57 57 0 0 0 .097-4.19A29.75 29.75 0 0 1 28 2.986 29.75 29.75 0 0 1 7.847 11.37",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M39.994 20.381a.875.875 0 0 1 0 1.238l-12.25 12.25a.875.875 0 0 1-1.238 0l-6.125-6.125a.875.875 0 1 1 1.238-1.238l5.506 5.507L38.756 20.38a.875.875 0 0 1 1.238 0",
		clipRule: "evenodd"
	})]
});
export default SvgIconPolicies;
